if (!customElements.get('sprouht-nav')) {
  customElements.define(
    'sprouht-nav',
    class SprouhtNav extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(min-width: 990px)');
        this.section = this.closest('.shopify-section');
        this.shell = this.querySelector('[data-sprh-shell]');
        this.announce = this.querySelector('[data-sprh-announce]');
        this.trigger = this.querySelector('[data-sprh-mega-trigger]');
        this.mega = this.querySelector('[data-sprh-mega]');
        this.burger = this.querySelector('[data-sprh-burger]');
        this.drawer = this.querySelector('[data-sprh-drawer]');
        this.sheet = this.querySelector('[data-sprh-sheet]');
        this.subOpen = this.querySelector('[data-sprh-sub-open]');
        this.subClose = this.querySelector('[data-sprh-sub-close]');
        this.cartLink = this.querySelector('[data-sprh-cart]');
        this.counts = Array.from(this.querySelectorAll('[data-sprh-count]'));
        this.sync = this.querySelector('#cart-icon-bubble');
        this.area = this.querySelector('.sprh__area');
        this.overlayEnabled = this.dataset.sprhOverlay === 'true';
        this.canHide = this.dataset.sprhSticky === 'true' && this.dataset.sprhScroll === 'reveal';
        this.hideAfter = Number(this.dataset.sprhHideAfter) || 0;
        this.lastY = window.scrollY;
        this.scrollTicking = false;

        this.closeTimer = null;
        this.hideTimer = null;
        this.drawerTimer = null;
        this.countTimer = null;

        this.onDocClick = this.onDocClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onViewport = this.onViewport.bind(this);
        this.onMq = this.onMq.bind(this);
        this.refreshCount = this.refreshCount.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onDeselect = this.onDeselect.bind(this);
        this.onCartClick = this.onCartClick.bind(this);
        this.checkOverlay = this.checkOverlay.bind(this);
        this.setHeights = this.setHeights.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.bindMega();
        this.bindDrawer();
        this.bindCart();
        this.bindAnnounce();
        this.checkOverlay();

        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((name) => {
          document.addEventListener(name, this.checkOverlay);
        });

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.checkOverlay, { once: true });
        }

        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onDeselect);
        window.addEventListener('resize', this.onViewport, { passive: true });
        window.addEventListener('scroll', this.onViewport, { passive: true });
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateScroll();
        window.addEventListener('pageshow', this.refreshCount);

        if (this.mq.addEventListener) {
          this.mq.addEventListener('change', this.onMq);
        } else if (this.mq.addListener) {
          this.mq.addListener(this.onMq);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onDeselect);
        window.removeEventListener('resize', this.onViewport);
        window.removeEventListener('scroll', this.onViewport);
        window.removeEventListener('scroll', this.onScroll);
        if (this.section) this.section.classList.remove('sprh-section--hidden');
        window.removeEventListener('pageshow', this.refreshCount);
        ['cart:updated', 'cart:refresh', 'cart:change'].forEach((name) => {
          document.removeEventListener(name, this.refreshCount);
        });
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((name) => {
          document.removeEventListener(name, this.checkOverlay);
        });
        document.documentElement.classList.remove('sprh-overlay');

        if (this.mq.removeEventListener) {
          this.mq.removeEventListener('change', this.onMq);
        } else if (this.mq.removeListener) {
          this.mq.removeListener(this.onMq);
        }

        if (this.syncObserver) this.syncObserver.disconnect();
        if (this.heightObserver) this.heightObserver.disconnect();
        if (typeof this.unsubscribeCart === 'function') this.unsubscribeCart();

        clearTimeout(this.closeTimer);
        clearTimeout(this.hideTimer);
        clearTimeout(this.drawerTimer);
        clearTimeout(this.countTimer);
        document.documentElement.classList.remove('sprh-lock');
      }

      bindMega() {
        if (!this.trigger || !this.mega) return;

        this.lastPointer = '';
        this.trigger.addEventListener('pointerdown', (event) => {
          this.lastPointer = event.pointerType;
        });

        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const mouseClick = event.detail !== 0 && this.lastPointer === 'mouse';
          this.lastPointer = '';
          if (mouseClick) {
            this.openMega();
            return;
          }
          if (this.isMegaOpen()) {
            this.closeMega();
          } else {
            this.openMega();
          }
        });

        [this.trigger, this.mega].forEach((el) => {
          el.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            this.openMega();
          });
          el.addEventListener('pointerleave', (event) => {
            if (event.pointerType !== 'mouse') return;
            this.scheduleClose();
          });
          el.addEventListener('focusout', (event) => {
            const next = event.relatedTarget;
            if (!next) return;
            if (next === this.trigger || this.mega.contains(next)) return;
            this.closeMega();
          });
        });
      }

      isMegaOpen() {
        return !!this.mega && this.trigger.getAttribute('aria-expanded') === 'true';
      }

      openMega() {
        if (!this.mega || !this.mq.matches) return;
        clearTimeout(this.closeTimer);
        clearTimeout(this.hideTimer);
        this.setMegaMax();
        if (this.mega.hidden) {
          this.mega.hidden = false;
          void this.mega.offsetWidth;
        }
        this.mega.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      scheduleClose() {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.closeMega(), 180);
      }

      closeMega() {
        if (!this.mega || this.mega.hidden) return;
        clearTimeout(this.closeTimer);
        this.mega.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
          if (!this.mega.classList.contains('is-open')) this.mega.hidden = true;
        }, 200);
      }

      setMegaMax() {
        if (!this.shell || !this.mega) return;
        const bottom = this.shell.getBoundingClientRect().bottom;
        const space = window.innerHeight - bottom - 24;
        this.mega.style.setProperty('--sprh-mega-max', `${Math.max(space, 240)}px`);
      }

      bindDrawer() {
        if (!this.burger || !this.drawer) return;

        this.burger.addEventListener('click', () => {
          if (this.classList.contains('sprh--menu-open')) {
            this.closeDrawer();
          } else {
            this.openDrawer();
          }
        });

        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.closeDrawer();
        });

        if (this.subOpen) {
          this.subOpen.addEventListener('click', () => this.openSub());
        }

        if (this.subClose) {
          this.subClose.addEventListener('click', () => this.closeSub());
        }
      }

      openDrawer() {
        if (!this.drawer || this.mq.matches) return;
        clearTimeout(this.drawerTimer);
        this.showBar();
        this.setDrawerTop();
        this.drawer.hidden = false;
        void this.drawer.offsetWidth;
        this.drawer.classList.add('is-open');
        this.classList.add('sprh--menu-open');
        this.burger.setAttribute('aria-expanded', 'true');
        this.burger.setAttribute('aria-label', this.burger.dataset.labelClose || 'Close menu');
        document.documentElement.classList.add('sprh-lock');
      }

      closeDrawer() {
        if (!this.drawer || this.drawer.hidden) return;
        this.drawer.classList.remove('is-open');
        this.classList.remove('sprh--menu-open', 'sprh--sub');
        this.burger.setAttribute('aria-expanded', 'false');
        this.burger.setAttribute('aria-label', this.burger.dataset.labelOpen || 'Open menu');
        document.documentElement.classList.remove('sprh-lock');
        clearTimeout(this.drawerTimer);
        this.drawerTimer = setTimeout(() => {
          if (this.drawer.classList.contains('is-open')) return;
          this.drawer.hidden = true;
          this.drawer.classList.remove('is-sub');
          if (this.sheet) this.sheet.scrollTop = 0;
        }, 220);
      }

      openSub() {
        if (!this.drawer) return;
        this.drawer.classList.add('is-sub');
        this.classList.add('sprh--sub');
        if (this.sheet) this.sheet.scrollTop = 0;
        if (this.subClose) this.subClose.focus({ preventScroll: true });
      }

      closeSub() {
        if (!this.drawer) return;
        this.drawer.classList.remove('is-sub');
        this.classList.remove('sprh--sub');
        if (this.sheet) this.sheet.scrollTop = 0;
        if (this.subOpen) this.subOpen.focus({ preventScroll: true });
      }

      setDrawerTop() {
        if (!this.shell) return;
        const bottom = Math.max(this.shell.getBoundingClientRect().bottom, 0);
        this.style.setProperty('--sprh-drawer-top', `${bottom}px`);
      }

      bindCart() {
        if (this.cartLink) this.cartLink.addEventListener('click', this.onCartClick);

        if (this.sync && 'MutationObserver' in window) {
          this.syncObserver = new MutationObserver(this.refreshCount);
          this.syncObserver.observe(this.sync, { childList: true, subtree: true, characterData: true });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refreshCount);
        }

        ['cart:updated', 'cart:refresh', 'cart:change'].forEach((name) => {
          document.addEventListener(name, this.refreshCount);
        });

        if (document.readyState === 'complete') {
          this.ensureCartScripts();
        } else {
          window.addEventListener('load', () => this.ensureCartScripts(), { once: true });
        }
      }

      onCartClick(event) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer || typeof cartDrawer.open !== 'function') return;
        event.preventDefault();
        this.closeMega();
        this.closeDrawer();
        cartDrawer.open(this.cartLink);
      }

      ensureCartScripts() {
        if (!document.querySelector('cart-drawer') || customElements.get('cart-drawer')) return;

        const load = (src) =>
          new Promise((resolve) => {
            if (!src) return resolve();
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            script.onerror = resolve;
            document.head.appendChild(script);
          });

        const core = customElements.get('cart-items') ? Promise.resolve() : load(this.dataset.sprhCartCore);
        core.then(() => {
          if (!customElements.get('cart-drawer')) load(this.dataset.sprhCartDrawer);
        });
      }

      refreshCount() {
        clearTimeout(this.countTimer);
        this.countTimer = setTimeout(() => {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => this.setCount(cart.item_count))
            .catch(() => {});
        }, 120);
      }

      setCount(count) {
        const total = Number(count) || 0;
        const label = total > 9 ? '9+' : String(total);
        this.counts.forEach((el) => {
          el.textContent = label;
          el.hidden = total === 0;
        });
        if (this.cartLink) {
          this.cartLink.setAttribute('aria-label', `${this.cartLink.dataset.label || 'Cart'} (${total})`);
        }
      }

      bindAnnounce() {
        this.setHeights();
        if ('ResizeObserver' in window) {
          this.heightObserver = new ResizeObserver(this.setHeights);
          if (this.announce) this.heightObserver.observe(this.announce);
          if (this.area) this.heightObserver.observe(this.area);
        }
      }

      setHeights() {
        const announceHeight = this.announce ? this.announce.offsetHeight : 0;
        const areaHeight = this.area ? this.area.offsetHeight : 0;
        if (this.section) this.section.style.setProperty('--sprh-announce-h', `${announceHeight}px`);
        document.documentElement.style.setProperty('--announcement-height', `${announceHeight}px`);
        document.documentElement.style.setProperty('--header-height', `${areaHeight}px`);
      }

      checkOverlay() {
        let active = false;
        if (this.overlayEnabled) {
          const first = document.querySelector('main .shopify-section');
          active = !!(first && first.querySelector('[data-header-transparent="true"]'));
        }
        document.documentElement.classList.toggle('sprh-overlay', active);
        this.classList.toggle('sprh--overlay', active);
      }

      onDocClick(event) {
        if (!this.isMegaOpen()) return;
        if (this.trigger.contains(event.target) || this.mega.contains(event.target)) return;
        this.closeMega();
      }

      onKey(event) {
        if (event.key !== 'Escape') return;
        if (this.isMegaOpen()) {
          this.closeMega();
          this.trigger.focus();
          return;
        }
        if (this.classList.contains('sprh--menu-open')) {
          if (this.drawer.classList.contains('is-sub')) {
            this.closeSub();
          } else {
            this.closeDrawer();
            this.burger.focus();
          }
        }
      }

      onScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        window.requestAnimationFrame(() => {
          this.scrollTicking = false;
          this.updateScroll();
        });
      }

      updateScroll() {
        const y = Math.max(window.scrollY, 0);
        this.classList.toggle('sprh--scrolled', y > 8);

        if (!this.canHide || !this.section) {
          this.lastY = y;
          return;
        }

        const busy = this.classList.contains('sprh--menu-open') || this.isMegaOpen();
        if (busy || y <= this.hideAfter) {
          this.showBar();
          this.lastY = y;
          return;
        }

        const delta = y - this.lastY;
        if (Math.abs(delta) < 6) return;

        if (delta > 0) {
          this.hideBar();
        } else {
          this.showBar();
        }
        this.lastY = y;
      }

      hideBar() {
        this.closeMega();
        this.section.classList.add('sprh-section--hidden');
      }

      showBar() {
        if (this.section) this.section.classList.remove('sprh-section--hidden');
      }

      onViewport() {
        if (this.classList.contains('sprh--menu-open')) this.setDrawerTop();
        if (this.isMegaOpen()) this.setMegaMax();
      }

      onMq() {
        this.closeMega();
        this.closeDrawer();
      }

      onSelect(event) {
        if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
        if (this.mq.matches) this.openMega();
      }

      onDeselect(event) {
        if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
        this.closeMega();
      }
    }
  );
}